function socialMediaIntegrationDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/social-media-integration/social-media-integration.html?$$REVISION$$'
  }
}

export { socialMediaIntegrationDialog }
